import { render } from "./clientRatesComp.vue?vue&type=template&id=5ecfc836&scoped=true"
import script from "./clientRatesComp.vue?vue&type=script&lang=js"
export * from "./clientRatesComp.vue?vue&type=script&lang=js"

import "./clientRatesComp.vue?vue&type=style&index=0&id=5ecfc836&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ecfc836"]])

export default __exports__